import {
    configureStore
} from '@reduxjs/toolkit';

import reducer
    from './reducers';


const store = configureStore({

    reducer,


    /*
    ========================================
    MIDDLEWARE REDUX
    ========================================

    En desarrollo Redux Toolkit controla
    que el estado no sea mutado directamente.

    Los catálogos de ubicación pueden contener
    miles de localidades y recorrerlos completos
    en cada dispatch genera el warning:

    ImmutableStateInvariantMiddleware took XXms

    Ignoramos únicamente:

    ubicacion.opciones

    El resto del estado continúa teniendo
    la protección normal de Redux.
    */

    middleware:
        (
            getDefaultMiddleware
        ) =>

            getDefaultMiddleware({

                immutableCheck: {

                    ignoredPaths: [
                        'ubicacion.opciones'
                    ]

                }

            })

});


export default store;